import type { SnackbarPartialProps, SnackbarContextT } from './types'

export const INITIAL_SNACKBAR_CONTEXT = {
  setSnackbarProps: (_props: SnackbarPartialProps) => {},
  openSnackbar: () => {},
} as SnackbarContextT
